export const START_FETCHING_PITCH_DATA = "START_FETCHING_PITCH_DATA";
export const ERROR_FETCHING_PITCH_DATA = "ERROR_FETCHING_PITCH_DATA";
export const SAVE_PITCH_DATA = "SAVE_PITCH_DATA";
// FOR FETCHING PITCH_DATA